document.addEventListener('DOMContentLoaded', function () {
  var bar = document.getElementById('sticky-cart-bar');
  var viewBtn = document.getElementById('sticky-cart-view-btn');
  var countEl = document.getElementById('sticky-cart-count');
  var totalEl = document.getElementById('sticky-cart-total');

  if (!bar) return;

  function refreshCartDisplay() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (cart.item_count > 0) {
          bar.classList.add('is-visible');
          countEl.textContent = cart.item_count;
          totalEl.textContent = formatMoney(cart.total_price);
        } else {
          bar.classList.remove('is-visible');
        }
      })
      .catch(function (error) {
        console.error('Unable to refresh the sticky cart display.', error);
      });
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return '₹' + amount;
  }

  // Initial check on page load
  refreshCartDisplay();

  // Refresh whenever Dawn's cart updates (covers Add to Cart actions anywhere on the site)
  document.addEventListener('cart:updated', refreshCartDisplay);
  document.addEventListener('cart:refresh', refreshCartDisplay);

  // Fallback: also refetch periodically after any Add to Cart form submission
  document.body.addEventListener('submit', function (event) {
    if (event.target.matches('form[action*="/cart/add"]')) {
      setTimeout(refreshCartDisplay, 600);
    }
  });

  // Open the existing cart drawer when "View Cart" is clicked
  viewBtn.addEventListener('click', function () {
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open(viewBtn);
    } else if (cartDrawer) {
      // Fallback: dispatch a click on a known open trigger, or toggle an attribute Dawn listens for
      cartDrawer.classList.add('active', 'animate');
      document.body.classList.add('overflow-hidden');
    } else {
      // Last resort fallback: navigate to the cart page
      window.location.href = '/cart';
    }
  });
});
